module.exports = __webpack_public_path__ + "static/service-4-973765a5acf8e86de7dcbffe2ade3eb4.jpg";